import React from 'react';
import { Link } from 'react-router-dom';

const HomeTwoSingleSlide = ({ slider_class,content_class, attr_1, attr_2, attr_3 = "We transform potential into excellence. Our expertise in data management, recruiting, and strategic consulting empowers businesses to achieve their goals and stay ahead in their industry.",btn_text}) => {
   return (
      <>
         <div className="single-slider single-slider-2 slider__height slider__height-2 d-flex align-items-center" style={{
            background: `url(assets/img/slider/02/slider-1.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover' }}>

            <div className="container">
               <div className="row">
                  <div className={`${slider_class}`}>
                     <div className={`slider__content slider__content-2 ${content_class && content_class}`}>
                         <div>
                           {attr_1 && attr_1}
                         </div>
                         <div>
                           {attr_2}
                         </div>
                         <div>
                           <p style={{ fontSize: '18px', lineHeight: '1.8', opacity: '0.95' }}>{attr_3}</p>
                         </div>
                        <div className="slider__btn">
                           <Link
                             to="/contact-us"
                             className="z-btn z-btn-transparent"
                             style={{
                               padding: '18px 48px',
                               fontSize: '17px',
                               fontWeight: '700',
                               letterSpacing: '0.5px',
                               borderRadius: '14px',
                               display: 'inline-block',
                               textAlign: 'center',
                               lineHeight: '1.5',
                               minWidth: '200px',
                               transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                             }}
                           >
                             {btn_text}
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default HomeTwoSingleSlide;